// extracted by mini-css-extract-plugin
export default {"wrapper":"Mo","form":"No","option":"Oo","radio":"Po","success":"Qo","contest":"Ro"};